import type { ReactNode } from 'react';

export const symbol_device_thermostat: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M338.5-138.5Q280-197 280-280q0-51 23-96t68-67v-328q0-45.42 32-77.21Q435-880 480-880t77 31.79q32 31.79 32 77.21v328q45 22 68 67t23 96q0 83-58.5 141.5T480-80q-83 0-141.5-58.5ZM431-515h98v-53h-49v-39h49v-87h-49v-38.5h49V-771q0-20.83-14.12-34.91-14.13-14.09-35-14.09Q459-820 445-805.91q-14 14.08-14 34.91v256Z"
		/>
	</svg>
);
